import { default as FluxActionTypes } from '../ActionTypes';
import Dispatcher from '../Dispatcher';
import ActionTypes from './ActionTypes';
import JwtStore from '../JwtStore'
import checkStatus from '../../utils/checkStatus';
import api from '../../utils/api';
import dispatchHttpError from '../../utils/dispatchHttpError';

export default {
  fetch(parentType, parentId, store, username) {
    return fetch(api(`report/${parentType}/${parentId}/${store}/${username}`), {
      headers: {
        'Authorization': `Bearer ${JwtStore.getToken()}`,
        'Accept': 'application/json'
      },
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(response => Dispatcher.dispatch({
        actionType: ActionTypes.USER_REPORT_STORE_FETCH_COMPLETE,
        data: response.data,
      }))
      .catch(dispatchHttpError);
  }
}
